import { notification } from 'antd';
import React from 'react';

export const Blocknotifications = (placement: any,message: any) => {
  notification.destroy()
  notification.config({
    duration: 36000
  });
  if(placement!==''){
    notification.info({
    message: `Access to your ${message} is blocked. Change your browser settings or system settings to allow Worktual to use your permissions.`,
    className: 'blocknot',
    placement
    });
  }
   

  return (<></>);
};